import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteInvoiceItemList', {
    sectionName: 'Items',
    itemColumnName: 'Item',
    itemFieldPlaceholder: 'Select item',
    descriptionColumnName: 'Description',
    descriptionFieldPlaceholder: 'Enter description',
    quantityColumnName: 'Quantity',
    quantityFieldPlaceholder: 'Enter value',
    unitsColumnName: 'Units',
    unitsFieldPlaceholder: 'Select units',
    priceLevelColumnName: 'Price level',
    priceLevelFieldPlaceholder: 'Select price level',
    unitPriceColumnName: 'Rate',
    unitPriceFieldPlaceholder: 'Enter value',
    amountColumnName: 'Amount',
    amountFieldPlaceholder: 'Enter amount',
    taxCodeColumnName: 'Tax code',
    taxCodeFieldPlaceholder: 'Select tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    grossAmountFieldPlaceholder: 'Enter gross amount',
    classColumnName: 'Class',
    classFieldPlaceholder: 'Select class',
    departmentColumnName: 'Department',
    departmentFieldPlaceholder: 'Select department',
    locationColumnName: 'Location',
    locationFieldPlaceholder: 'Select location',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
